import styled, { css } from 'styled-components';
import * as RTable from 'react-super-responsive-table';
import { tokens } from '../../design/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px 40px 40px;
  gap: 16px;

  @media (max-width: 660px) {
    padding: 0;
  }

  transition: margin-left 0.5s;
`;

export const TitleContainer = styled.article`
  display: flex;
  flex-direction: row;
  gap: 120px;
  margin-bottom: 20px;
`;

export const Title = styled.h1`
  color: ${tokens.color.textWhite};
`;

export const ListContainer = styled.article`
  width: 100%;
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  padding: 48px 0;
`;

export const Table = styled(RTable.Table)`
  color: ${tokens.color.textWhite};
  border-collapse: separate;
  border-spacing: 12px 30px;
`;

interface ITr {
  withInteraction?: boolean;
  alignAtEnd?: boolean;
}

export const Tbody = styled(RTable.Tbody)``;

export const Tr = styled(RTable.Tr)<ITr>`
  /* A linha nao cresce mais no hover (transform: scale) — era um efeito que
     quebrava o alinhamento das colunas. Agora o hover apenas clareia o fundo
     e mantem a coluna estavel. */
  transition: background-color 0.2s;
  margin-top: 8px;

  ${({ withInteraction }) =>
    withInteraction &&
    css`
      &:hover {
        background-color: ${tokens.color.cardCharcoal};
        cursor: pointer;
      }
    `}
`;

export const Th = styled(RTable.Th)`
  text-align: center;
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: 8px;
  padding: 8px;
  user-select: none;
  position: relative;
  color: ${tokens.color.textAsh};
`;

export const Td = styled(RTable.Td)`
  color: ${tokens.color.textWhite};
  text-align: center;

  @media screen and (max-width: 40em) {
    margin: 0 0 12px 0 !important;
  }
`;

export const DangerButton = styled.button`
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid ${tokens.color.errorRed};
  background-color: transparent;
  color: ${tokens.color.errorRed};
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover:not(:disabled) {
    background-color: ${tokens.color.errorRed};
    color: #fff;
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PageCount = styled.p`
  color: ${tokens.color.textAsh};

  @media screen and (max-width: 40em) {
    margin-left: 16px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const HeaderText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

export const IconsContainer = styled.div`
  position: absolute;
  right: 8px;
  cursor: pointer;
`;

export const FilterInput = styled.input`
  width: 100%;
  margin-top: 4px;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid #ccc;
  text-align: center;
`;
